/**
 * @Author: Alex Sorafumo <Yuion>
 * @Date:   13/09/2016 2:55 PM
 * @Email:  alex@yuion.net
 * @Filename: tab-head.component.ts
 * @Last modified by:   Yuion
 * @Last modified time: 15/12/2016 11:32 AM
 */

import { Component, Input, TemplateRef } from '@angular/core';

import { BaseWidgetComponent } from '../../../shared/base.component';
import { TabGroupComponent } from './tabs.component';

@Component({
    selector: 'tab',
    template: `
        <div [class]="'tab' + (klass ? ' ' + klass : '')" widget [class.active]="active" (click)="setActive()">
            <ng-content></ng-content>
        </div>`,
    styles: [`.tab{border-radius:.15em .15em 0 0;bottom:-2px;margin:0 .1em;padding:.5em 1.5em;position:relative;background-color:#f2f2f2;color:rgba(0,0,0,.87);cursor:pointer;min-width:4em;-webkit-transition:color .3s,background-color .3s;transition:color .3s,background-color .3s;border:1px solid #f2f2f2}.tab:hover{background-color:#e6e6e6}.active{border-bottom:.1em solid #fff;background-color:#fff;color:rgba(0,0,0,.87)}.active:hover{background-color:#fff;color:rgba(0,0,0,.87)}`],
})
export class TabHeadComponent extends BaseWidgetComponent {
    @Input() public id: string;
    @Input() public active: boolean;
    @Input() public template: TemplateRef<any>;

    public parent: TabGroupComponent = null;

    public setActive() {
        if (this.parent) {
            this.parent.active = this.id;
        }
    }
}
